import React, { Component } from "react";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import firebase from "./firebase";
class ContactSection extends Component {
  constructor(props) {
    super(props);
    this.state = { name: "", email: "", message: "" };
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(event) {
    if (event.target.id === "formBasicName")
      this.setState({ name: event.target.value });
    if (event.target.id === "formBasicEmail")
      this.setState({ email: event.target.value });
    if (event.target.id === "formBasicMessage")
      this.setState({ message: event.target.value });
  }
  render() {
    return (
      <div className="p-3 mb-2 bg-info text-white">
        <h1 align="center">Contact Us</h1>

        <div align="center">
          <Form
            onSubmit={this.validateForm}
            style={{
              width: "50%"
              /* marginLeft: "300px", marginRight: "300px" */
            }}
          >
            <Form.Group controlId="formBasicName">
              <Form.Control
                size="lg"
                type="text"
                placeholder="Name"
                value={this.state.name}
                onChange={this.handleChange}
              />
            </Form.Group>

            <Form.Group controlId="formBasicEmail">
              <Form.Control
                size="lg"
                type="email"
                placeholder="Enter email"
                value={this.state.email}
                onChange={this.handleChange}
              />
            </Form.Group>

            <Form.Group controlId="formBasicMessage">
              <Form.Control
                size="lg"
                type="text"
                placeholder="Message"
                value={this.state.message}
                onChange={this.handleChange}
                style={{ height: "100px" }}
              />
            </Form.Group>

            <Button onClick={this.submitForm} variant="success" type="submit">
              Send
            </Button>
          </Form>
        </div>
      </div>
    );
  }

  submitForm = () => {
    if (this.state.name === "") {
      alert("You have to enter you'r name");
      return false;
    }
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (!re.test(String(this.state.email).toLowerCase())) {
      alert("You have entered an invalid email address ");
      return false;
    }

    if (this.state.message == "") {
      alert("You have to enter a Message ");
      return false;
    }
    this.handleSendMessage();
  };

  handleSendMessage = () => {
    firebase
      .database()
      .ref("ContactWithUs/")
      .push(
        {
          name: this.state.name,
          email: this.state.email,
          subject: this.state.message
        },
        function(error) {
          if (error) {
            // The write failed...
          } else {
            // Data saved successfully!
            alert("The message is sent! ");
          }
        }
      );
  };
}

export default ContactSection;
